import { GetAllRegularTotemClosedDayQuery, TotemClosedDayFragmentFragment } from 'data/__generated__';
import { GET_ALL_REGULAR_TOTEM_CLOSED_DAY_QUERY } from 'data/queries/totemClosedDay';
import { apolloClient } from '../../../App';

export const totemClosedDayCreatedHandler = (createdTotemClosedDay: TotemClosedDayFragmentFragment) => {
    const result = apolloClient.readQuery<GetAllRegularTotemClosedDayQuery>({
        query: GET_ALL_REGULAR_TOTEM_CLOSED_DAY_QUERY,
    });
    if (result === null) {
        return;
    }
    const currentTotemClosedDays = result.getAllRegularTotemClosedDay;

    // if the current totem closed days already contains the created one, then we need to update it with the sent values (and keep it at the same index)
    const newTotemClosedDays = currentTotemClosedDays.find(({ _id }) => _id === createdTotemClosedDay._id)
        ? currentTotemClosedDays.map((totemClosedDay) =>
              totemClosedDay._id === createdTotemClosedDay._id ? createdTotemClosedDay : totemClosedDay,
          )
        : [...currentTotemClosedDays, createdTotemClosedDay];

    apolloClient.writeQuery<GetAllRegularTotemClosedDayQuery>({
        query: GET_ALL_REGULAR_TOTEM_CLOSED_DAY_QUERY,
        data: { getAllRegularTotemClosedDay: newTotemClosedDays },
    });
};

export const totemClosedDayRemovedHandler = (removedTotemClosedDayId: string) => {
    const result = apolloClient.readQuery<GetAllRegularTotemClosedDayQuery>({
        query: GET_ALL_REGULAR_TOTEM_CLOSED_DAY_QUERY,
    });
    if (result === null) {
        return;
    }
    const currentTotemClosedDays = result.getAllRegularTotemClosedDay;

    // if the current totem closed days already contains the created one, then we need to update it with the sent values (and keep it at the same index)
    const newTotemClosedDays = currentTotemClosedDays.filter(
        (totemClosedDay) => totemClosedDay._id !== removedTotemClosedDayId,
    );

    apolloClient.writeQuery<GetAllRegularTotemClosedDayQuery>({
        query: GET_ALL_REGULAR_TOTEM_CLOSED_DAY_QUERY,
        data: { getAllRegularTotemClosedDay: newTotemClosedDays },
    });
};
